module.exports = __webpack_public_path__ + "img/csr_111123_F.27b5a49b.jpg";